<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="原订单ID" prop="originalOrderId">
        <el-input
          v-model="queryParams.originalOrderId"
          class="!w-240px"
          clearable
          placeholder="请输入原订单ID"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="续租类型" prop="extensionType">
        <el-select
          v-model="queryParams.extensionType"
          class="!w-240px"
          clearable
          placeholder="请选择续租类型"
        >
          <el-option label="同房续住" value="SAME_ROOM" />
          <el-option label="换房续租" value="CHANGE_ROOM" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="queryParams.status"
          class="!w-240px"
          clearable
          placeholder="请选择状态"
        >
          <el-option label="待确认" value="PENDING" />
          <el-option label="已确认" value="CONFIRMED" />
          <el-option label="已支付" value="PAID" />
          <el-option label="已取消" value="CANCELLED" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:extension-order:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="原订单ID" prop="originalOrderId" min-width="120" />
      <el-table-column align="center" label="续租单ID" prop="extensionOrderId" min-width="120" />
      <el-table-column align="center" label="续租类型" prop="extensionType" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.extensionType === 'SAME_ROOM'" type="primary">同房续住</el-tag>
          <el-tag v-else-if="scope.row.extensionType === 'CHANGE_ROOM'" type="warning">换房续租</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="原退房日期" prop="originalCheckOutDate" min-width="120" />
      <el-table-column align="center" label="新退房日期" prop="newCheckOutDate" min-width="120" />
      <el-table-column align="center" label="原房间ID" prop="originalRoomId" min-width="100" />
      <el-table-column align="center" label="新房间ID" prop="newRoomId" min-width="100" />
      <el-table-column align="center" label="续住天数" prop="extensionDays" min-width="80" />
      <el-table-column align="center" label="原金额" prop="originalAmount" min-width="100">
        <template #default="scope">
          {{ scope.row.originalAmount != null ? '￥' + scope.row.originalAmount : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="新金额" prop="newAmount" min-width="100">
        <template #default="scope">
          {{ scope.row.newAmount != null ? '￥' + scope.row.newAmount : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="差额" prop="diffAmount" min-width="100">
        <template #default="scope">
          {{ scope.row.diffAmount != null ? '￥' + scope.row.diffAmount : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="status" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.status === 'PENDING'" type="info">待确认</el-tag>
          <el-tag v-else-if="scope.row.status === 'CONFIRMED'" type="primary">已确认</el-tag>
          <el-tag v-else-if="scope.row.status === 'PAID'" type="success">已支付</el-tag>
          <el-tag v-else-if="scope.row.status === 'CANCELLED'" type="warning">已取消</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:extension-order:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:extension-order:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="120px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="原订单ID" prop="originalOrderId">
        <el-input v-model="formData.originalOrderId" placeholder="请输入原订单ID" />
      </el-form-item>
      <el-form-item label="续租单ID" prop="extensionOrderId">
        <el-input v-model="formData.extensionOrderId" placeholder="请输入续租单ID" />
      </el-form-item>
      <el-form-item label="续租类型" prop="extensionType">
        <el-radio-group v-model="formData.extensionType">
          <el-radio value="SAME_ROOM">同房续住</el-radio>
          <el-radio value="CHANGE_ROOM">换房续租</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="原退房日期" prop="originalCheckOutDate">
        <el-date-picker
          v-model="formData.originalCheckOutDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择原退房日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="新退房日期" prop="newCheckOutDate">
        <el-date-picker
          v-model="formData.newCheckOutDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择新退房日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="原房间ID" prop="originalRoomId">
        <el-input v-model="formData.originalRoomId" placeholder="请输入原房间ID" />
      </el-form-item>
      <el-form-item label="新房间ID" prop="newRoomId">
        <el-input v-model="formData.newRoomId" placeholder="请输入新房间ID" />
      </el-form-item>
      <el-form-item label="续住天数" prop="extensionDays">
        <el-input-number
          v-model="formData.extensionDays"
          :min="1"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="原金额" prop="originalAmount">
        <el-input-number
          v-model="formData.originalAmount"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="新金额" prop="newAmount">
        <el-input-number
          v-model="formData.newAmount"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="差额" prop="diffAmount">
        <el-input-number
          v-model="formData.diffAmount"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio value="PENDING">待确认</el-radio>
          <el-radio value="CONFIRMED">已确认</el-radio>
          <el-radio value="PAID">已支付</el-radio>
          <el-radio value="CANCELLED">已取消</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as ExtensionOrderApi from '@/api/hotel/extensionOrder'
import { getShopSimpleList } from '@/api/hotel/platformShop'

defineOptions({ name: 'HotelExtensionOrder' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  originalOrderId: undefined,
  extensionType: undefined,
  status: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await ExtensionOrderApi.getExtensionOrderPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<ExtensionOrderApi.ExtensionOrderVO>({
  id: undefined,
  shopId: undefined,
  originalOrderId: 0,
  extensionOrderId: undefined,
  extensionType: 'SAME_ROOM',
  originalCheckOutDate: '',
  newCheckOutDate: '',
  originalRoomId: undefined,
  newRoomId: undefined,
  extensionDays: 1,
  originalAmount: 0,
  newAmount: 0,
  diffAmount: 0,
  status: 'PENDING',
  createTime: undefined as any
})
const formRules = reactive({
  originalOrderId: [{ required: true, message: '原订单不能为空', trigger: 'blur' }],
  extensionType: [{ required: true, message: '续租类型不能为空', trigger: 'change' }],
  originalCheckOutDate: [{ required: true, message: '原退房日期不能为空', trigger: 'change' }],
  newCheckOutDate: [{ required: true, message: '新退房日期不能为空', trigger: 'change' }],
  extensionDays: [{ required: true, message: '续住天数不能为空', trigger: 'blur' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await ExtensionOrderApi.getExtensionOrder(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await ExtensionOrderApi.createExtensionOrder(data)
      message.success(t('common.createSuccess'))
    } else {
      await ExtensionOrderApi.updateExtensionOrder(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    shopId: undefined,
    originalOrderId: 0,
    extensionOrderId: undefined,
    extensionType: 'SAME_ROOM',
    originalCheckOutDate: '',
    newCheckOutDate: '',
    originalRoomId: undefined,
    newRoomId: undefined,
    extensionDays: 1,
    originalAmount: 0,
    newAmount: 0,
    diffAmount: 0,
    status: 'PENDING',
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await ExtensionOrderApi.deleteExtensionOrder(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getShopList()
})
</script>
